import styles from './index.module.scss';

interface Props {
    children: any;
    type: 'buy' | 'more';
    onClick: Function;
}

const Button: React.FC<Props> = (props) => {
    return (
        <div className={props.type === 'buy' ? styles.Button : styles.ButtonLearnMore} onClick={() => props.onClick && props.onClick()}>
            {props.children}
        </div>
    );
};

export default Button;
